import { combineReducers } from "redux";

// Authentication
import LoginReducer, { logoutUserSuccess } from "./auth/login/reducer";

// Dashboard
import DashboardReducer from "./dashboard/reducer";

const appReducer = combineReducers({
    Login: LoginReducer,
    Dashboard: DashboardReducer
});

// Wipe every slice back to its initial state on logout so no account info
// leaks into the next session.
const rootReducer = (state: any, action: any) => {
    if (action.type === logoutUserSuccess.type) {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

export default rootReducer;